import itemReducer from './items';
export * from './items';

export default { restrictedItems: itemReducer };
